import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from "@angular/router";
import {Constants} from "../../../services/constants";
import {HttpApiService} from "../../../services/http-api.service";
import {EndpointsService} from "../../../services/endpoints.service";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
  code: string;
  username: string;
  isRequested: boolean = false;
  isRequesting: boolean = false;
  errorMessage: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private Api: HttpApiService,
              private endpoints: EndpointsService) {
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(data => {
        this.code = data['id'];
        this.username = data['username'];
        if(!this.code || !this.username) {
          this.router.navigateByUrl("/login");
        }
      });
  }

  submit(password) {
    if(!password) {
      return false;
    }
    this.resetPassword(password);
    return false;
  }

  resetPassword(password) {
    this.errorMessage = null;
    this.isRequesting = true;
    let data: any = {};
    data.username = this.username;
    data.code = this.code;
    data.password = password;
    this.Api.put(this.endpoints.getResetPasswordUrl(), data, false)
      .subscribe(response => {
          this.isRequested = true;
          this.isRequesting = false;
        },
        error => {
          this.errorMessage = JSON.parse(error._body).message;
          this.isRequesting = false;
        })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/user/reset-password/reset-password.component.ts